<template>
  <a v-if="isExternalLink || !props.to" v-bind="$attrs" :href="href" :class="[props.color, decorationClass]">
    <slot />
  </a>
  <RouterLink v-else :to="props.to" v-slot="{ href, navigate }" custom>
    <a v-bind="$attrs" :href="href" :class="[props.color, decorationClass]" @click="navigate">
      <slot />
    </a>
  </RouterLink>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouteLocationRaw, RouterLink } from 'vue-router';

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<{ to?: RouteLocationRaw; color?: 'inherit' | 'accent'; decoration?: boolean }>(),
  {
    color: 'inherit',
    decoration: true,
  },
);
const decorationClass = computed(() => (props.decoration ? 'decoration' : ''));
const href = computed(() => props.to as string);
const isExternalLink = computed(
  () =>
    (typeof props.to === 'string' && props.to.startsWith('http')) ||
    (typeof props.to === 'string' && props.to.startsWith('tel')),
);
</script>

<style scoped lang="scss">
a {
  font-size: inherit;
  line-height: inherit;
  text-decoration: none;

  &.decoration:hover {
    text-decoration: underline;
  }

  &.accent {
    color: var(--t-color-blue-500);
    font-weight: 600;
  }
}
</style>
